export default {
  title: 'Our Services',
  consulting: {
    title: 'Consulting',
    description: 'Professional assistance in making real estate decisions.',
    more: 'More',
  },
  ai_valuation: {
    title: 'AI Valuation',
    description: 'Instant property valuation using algorithms.',
    more: 'Learn more',
  },
  market_analytics: {
    title: 'Market Analytics',
    description: 'Regular reports on real estate trends.',
    more: 'Read more',
  },
  data_security: {
    title: 'Data Security',
    description: 'Modern methods of storing and handling your data.',
    more: 'More',
  },
  automation: {
    title: 'Automation',
    description: 'Reduce manual work by automating processes.',
    more: 'Show',
  },
  internet_solutions: {
    title: 'Internet Solutions',
    description: 'Integration with digital services and smart homes.',
    more: 'Explore',
  }
}
